import { EditOutlined, EyeOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Card, Space, Table, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
// import EmpresaContext from '../../context/empresa-context';
import { DEFAULT_PAGE_SIZE, errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

const styles = {
  menuAction: {
    marginLeft: 10
  }
};

function ProveedorList(props) {
  // const { empresa } = useContext(EmpresaContext);
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: '10px'
    },
    /* {
      title: 'Empresa',
      dataIndex: ['empresa', 'nombre'],
      width: '20%',
      render: (nombre) => `${nombre}`
    }, */
    {
      title: 'Nombre',
      dataIndex: 'nombre'
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono1'
    },
    {
      title: 'Web',
      dataIndex: 'web'
    },
    {
      title: 'Dirección',
      dataIndex: 'direccion'
    },
    {
      title: 'Mail',
      dataIndex: 'mail'
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Ver Proveedor">
            <Button
              type="text"
              icon={<EyeOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`proveedores/view/${record.id}`)}
            />
          </Tooltip>
          <Tooltip title="Editar Proveedor">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`proveedores/form/${record.id}`)}
            />
          </Tooltip>
        </Space>
      ),
      align: 'left'
    }
  ];
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    showSizeChanger: true
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  // const [loadingState, setLoadingState] = useState(0);

  /* const toggle = async (record) => {
    try {
      setLoadingState(record.id);
      if (record.activo) {
        await instanceRef.instance.post(`promocion/disable/${record.id}`, {});
      } else {
        await instanceRef.instance.post(`promocion/enable/${record.id}`, {});
      }
      setData({
        ...data,
        rows: data.rows.map((item) => {
          if (item.id === record.id) {
            // eslint-disable-next-line no-param-reassign
            item.activo = !record.activo;
          }
          return item;
        })
      });
    } catch (error) {
      errorHandler(error);
    }
    setLoadingState(0);
  }; */
  const handleOpenUrl = (url) => {
    history.push(url);
  };

  const fetch = async (propsParam) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get('proveedor', {
        params: {
          ...propsParam.pagination,
          filters: { ...propsParam.filters }
        }
      });
      if (response.data?.data) {
        setData({ ...response.data.data });
        setPagination({
          ...propsParam.pagination,
          total: response.data.data.count
        });
      }
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetch({ pagination });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTableChange = (paginationParam, filters, sorter) => {
    // TODO: add sorting
    fetch({
      // sortField: sorter.field,
      // sortOrder: sorter.order,
      sorter: [{ field: sorter.field, order: sorter.order }],
      pagination: paginationParam,
      filters
    });
  };

  return (
    <ResponsiveContainer size="large">
      <Card
        title="Proveedores"
        style={{ textAlign: 'left' }}
        extra={[
          <Button
            key="2"
            type="dashed"
            shape="round"
            icon={<PlusOutlined />}
            size="middle"
            onClick={() => props.history.push(`proveedores/form`)}
            style={styles.menuAction}
          >
            Agregar
          </Button>
        ]}
      >
        <div style={{ overflow: 'auto' }}>
          <Table
            size="small"
            bordered
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={data && data.rows}
            pagination={pagination}
            loading={loading}
            onChange={handleTableChange}
            rowClassName="table-small"
          />
        </div>
      </Card>
    </ResponsiveContainer>
  );
}

export default ProveedorList;
